import React, { useState, useEffect } from "react";
import { Container, Row, Col, Carousel, CarouselItem, CarouselControl, CarouselIndicators } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../styles/AllEquipment.css";

const AllEquipment = () => {
  const [equipmentData, setEquipmentData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEquipment = async () => {
      try {
        const response = await axios.get(
          "https://techcrew.pk/ulc/Get_Equipment.php"
        );

        if (response.data.status.code === 200) {
          const activeEquipment = response.data.data.filter(
            (item) => item.status === "Active"
          );
          setEquipmentData(activeEquipment);
        } else {
          console.error(
            "Failed to fetch equipment:",
            response.data.status.message
          );
        }
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEquipment();
  }, []);

  return (
    <section className="equipment-section">
      <Container>
        <Row>
          <Col lg="12" className="text-center mb-5">
            <h3 className="section__title">Our Equipment</h3>
            <div className="title-divider"></div>
          </Col>

          {loading ? (
            <Col lg="12" className="text-center">
              <div className="loading-spinner">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </Col>
          ) : (
            <>
              {equipmentData.map((item) => (
                <EquipmentCard item={item} key={item.equipment_id} />
              ))}

             
            </>
          )}
        </Row>
      </Container>
    </section>
  );
};

// ✅ Equipment Card with Carousel
const EquipmentCard = ({ item }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === item.pictures.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? item.pictures.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  return (
    <Col lg="3" md="6" sm="12" className="mb-4">
      <div className="equipment__card simple-card">
        <div className="equipment__img">
          <Carousel
            activeIndex={activeIndex}
            next={next}
            previous={previous}
          >
            <CarouselIndicators
              items={item.pictures}
              activeIndex={activeIndex}
              onClickHandler={goToIndex}
            />
            {item.pictures.map((pic, idx) => (
              <CarouselItem
                key={idx}
                onExiting={() => setAnimating(true)}
                onExited={() => setAnimating(false)}
              >
                <img
                  src={`https://techcrew.pk/ulc/${pic}`}
                  alt={`${item.equipment_name}-${idx}`}
                  className="equipment-image"
                />
              </CarouselItem>
            ))}
            <CarouselControl
              direction="prev"
              directionText="Previous"
              onClickHandler={previous}
            />
            <CarouselControl
              direction="next"
              directionText="Next"
              onClickHandler={next}
            />
          </Carousel>
        </div>
        <div className="equipment__content text-center">
          <p style={{fontSize:'22px',fontWeight:'bold'}}>{item.equipment_name}</p>
        </div>
      </div>
    </Col>
  );
};

export default AllEquipment;
